import { createAsyncThunk } from "@reduxjs/toolkit";
import CAxios from "../utils/CAxios";
import axios, { AxiosResponse } from "axios";
import dayjs from "dayjs";

export const toGetAppointementSlot = createAsyncThunk(
  "appointment/slots",
  async (data: any) => {
    try {
      const response = await CAxios.post(
        `appointment_slots`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetBranches = createAsyncThunk<
  AxiosResponse<any, any>,
  string
>("appointment/branches", async (lang) => {
    try {
      const response = await CAxios.get(`branches?lang=${lang}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const toGetMyAppointments = createAsyncThunk<
  AxiosResponse<any, any>,
  string
>(
  "appointment/my",
  async (lang) => {
    try {
      const response = await CAxios.get(`my/orders?lang=${lang}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as {
        appointmens?: { myAppointments?: { status?: string } };
      };
      const status = state.appointmens?.myAppointments?.status;
      return status === "idle";
    },
  }
);

export const toGetMyInvoices = createAsyncThunk(
  "invoices/my",
  async () => {
    try {
      const response = await CAxios.get(`my/invoices`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as { appointmens?: { myInvoices?: { status?: string } } };
      const status = state.appointmens?.myInvoices?.status;
      return status === "idle";
    },
  }
);

export const toCreateAppointment = createAsyncThunk(
  "appointment/create",
  async (data: any) => {
    try {
      const response = await CAxios.post(`appointments`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toAddCoupon = createAsyncThunk("coupon/add", async (data: any) => {
  try {
    const response = await CAxios.post(`shop/apply`, data);
    return response;
  } catch (error) {
    throw error;
  }
});

// to print order
export const toPrintOrder = createAsyncThunk<
  AxiosResponse<any, any>,
  { id: any; lang: any }
>("order/print", async ({ id, lang }) => {
  const config = {
    responseType: "blob" as const,
  };
  const { data } = await CAxios.get(
    `order/print/${id}?lang=${lang}`,
    config
  );
  const pdfBlob = new Blob([data], { type: "application/pdf" });
  const fileURL = URL.createObjectURL(pdfBlob);
  const link = document.createElement("a");
  link.href = fileURL;
  link.download = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss") + ".pdf";
  link.click();
  return data;
});

// to print invoice
export const toPrintInvoice = createAsyncThunk<
  AxiosResponse<any, any>,
  { id: any; lang: any }
>("invoice/print", async ({ id, lang }) => {
  const config = {
    responseType: "blob" as const,
    headers: {
      "Content-Type": "application/json",
    },
  };
  const { data } = await CAxios.get(
    `invoice/print/${id}?lang=${lang}`,
    config
  );
  const pdfBlob = new Blob([data], { type: "application/pdf" });
  const fileURL = URL.createObjectURL(pdfBlob);
  const link = document.createElement("a");
  link.href = fileURL;
  link.download = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss") + ".pdf";
  link.click();
  return data;
});
